import { render, staticRenderFns } from "./InventoryBatchBoxDetail.vue?vue&type=template&id=7278a55a&"
import script from "./InventoryBatchBoxDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryBatchBoxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports